export const validateEmail = (email: string) => {
  const emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegExp.test(email) ? '' : 'Невірна електронна адреса';
};
